module.exports = __webpack_public_path__ + "static/magnifying-glass-5032b807d98649467c0e34af06a4bf40.svg";